import Link from 'next/link';

const Footer = () => {
  return (
    <section className="flex justify-center flex-wrap pb-10 pt-2 text-(--gray-text) gap-x-6 mx-4 *:py-2 [&>a]:font-medium [&>a]:hover:text-(--purple) [&>a]:transition-colors">
      <Link href="/about" prefetch={false}>
        Humbo™
      </Link>

      <Link href="/visited" prefetch={false}>
        Visited countries map
      </Link>

      <Link href="/travel-bucket-list" prefetch={false}>
        Travel bucket list
      </Link>

      <Link href="/quiz" prefetch={false}>
        Travel quizzes
      </Link>

      <Link href="/top100" prefetch={false}>
        Top 100 destinations
      </Link>

      <Link href="/privacy-policy" prefetch={false}>
        Privacy
      </Link>

      <Link href="/terms" prefetch={false}>
        Terms
      </Link>
    </section>
  );
};

export default Footer;
